module.exports = __webpack_public_path__ + "static/media/1-1_Art_Card_One_Page_02.fa25de63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/1-1_Art_Card_One_Page_02.jpg
// module id = 1699
// module chunks = 0